<cm-spinner [loading]="loading()" size="small">
  <button
    type="button"
    [disabled]="disabled()"
    class="action-button"
    [class]="buttonClasses()"
    [attr.aria-label]="ariaLabel()"
    [attr.aut-id]="autId()"
    [cmTooltip]="title()"
  >
    <cm-icon
      [class.not-size-selected]="!iconSize()"
      [color]="iconColor()"
      [mode]="iconMode()"
      [name]="iconName()"
      [size]="iconSize() || 'lg'"
    />
  </button>
</cm-spinner>
